import { useEffect, useMemo, useState } from 'react'
import { getGiftCatalog, type GiftCatalogItemDTO } from '../api/gifts'

export type GiftDef = {
  id: string
  emoji: string
  name: string
  amountCents: number
  amountLabel: string
}

export function mapCatalogToGiftDefs(items: GiftCatalogItemDTO[] = []): GiftDef[] {
  return items.map((i) => ({
    id: i.id,
    emoji: i.emoji,
    name: i.name,
    amountCents: i.default_amount_cents ?? 0,
    amountLabel: (i.default_amount_cents ?? 0) === 0 ? 'FREE' : `$${((i.default_amount_cents ?? 0) / 100).toFixed(0)}`,
  }))
}

export function useGiftCatalog() {
  const [items, setItems] = useState<GiftCatalogItemDTO[] | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    getGiftCatalog()
      .then((res) => { if (!cancelled) setItems(res) })
      .catch((e) => { if (!cancelled) setError(e?.message || 'Failed to load gifts') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [])

  const defs = useMemo(() => mapCatalogToGiftDefs(items || []), [items])
  return { items: defs, loading, error }
}

